var EditProgramRequestModel = /** @class */ (function () {
    function EditProgramRequestModel() {
    }
    return EditProgramRequestModel;
}());
export { EditProgramRequestModel };
